import { ToastService } from "@shared/lib/services";
import {
  ACCOUNT_STATUS,
  BackednResponse,
  BrandType,
  GetBrands,
} from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRAND_LIST_QUERY_KEY } from "../constants";
import { BrandService } from "../services/brand.service";

export function useGetBrands(
  limit: number,
  pageNo: number,
  searchQuery?: string,
  status?: ACCOUNT_STATUS[],
  type?: BrandType[],
  permissionedUserBrandIds?: string[],
  companyName?: string[],
) {
  const { data, isLoading, isError, error, isFetching, refetch } = useQuery<
    BackednResponse<GetBrands>
  >({
    queryKey: [
      ...BRAND_LIST_QUERY_KEY,
      searchQuery,
      limit,
      pageNo,
      status,
      type,
      permissionedUserBrandIds,
      companyName,
    ],
    queryFn: () =>
      BrandService.getBrands(
        limit,
        pageNo,
        searchQuery,
        status,
        type,
        permissionedUserBrandIds,
        companyName,
      ),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    brands: data?.data,
    isError,
    isFetching: isLoading,
    isFetchingOrig: isFetching,
    refetch
  };
}
